import React from 'react';
import { Link } from '../../../env';
const Commercial = () => {
    return (
        <div className='w-full h-full relative'>
            <div className='w-full h-full absolute top-0 left-0 z-0 bg-[#212f3c] opacity-[0.9]'></div>
            <div className='w-full h-full absolute top-0 left-0 z-10 flex justify-between'>
                <div className='w-[50%] h-full flex items-center justify-center'>
                    <div className='w-[450px] h-[450px] 2xl:w-[500px] 2xl:h-[500px] bg-white rounded-full'>
                        <img src={`${Link}/assets/JPEG/commercial.jpeg`} alt='CommercialComponent' className='w-full h-full bg-cover rounded-full' />
                    </div>
                </div>
                <div className='w-[50%] h-full'>
                    <div className='w-full mt-[130px] 2xl:mt-[90px] text-white'>
                        <h1 className='poppins-medium text-white text-[20px] 2xl:text-[30px] text-center -translate-x-[20px] 2xl:-translate-x-0'>Stay Connected with IRSystemTuning Latest Updates</h1>
                    </div>
                    <div className='w-full mt-[40px] 2xl:mt-[40px] px-[20px] 2xl:px-[100px]'>
                        <div className='w-full h-[80px] rounded-xl -translate-x-[20px] 2xl:-translate-x-0'>
                            <div className='w-full h-full flex'>
                                <button className='text-white w-[100px] 2xl:w-[100px] cursor-pointer hover:bg-transparent rounded-tl-xl rounded-bl-xl h-full bg-[#07429c] flex justify-center items-center'>
                                    <img src={`${Link}/assets/Icons/submit.png`} alt='Submit' className='w-[50px]' />
                                </button>
                                <div className='w-full h-full flex border-2 rounded-tr-xl rounded-br-xl'>
                                    <input type='text' className='w-full h-full bg-slate-300 focus:ring-0 focus:outline-none px-5 poppins-medium placeholder:text-black rounded-tr-lg rounded-br-lg' placeholder='Enter Email ...' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Commercial;
